import { Component } from '@angular/core';

@Component({
    selector: 'ui-popover-docs-preview',
    templateUrl: './popover.docs.preview.html',
    styleUrls: ['./popover.docs.preview.scss'],
})
export class UIPopoverDocsPreview {
}
